import * as constants from "./constants";

export const CALL_PREFERENCE_FLAG = {
  SIP: "SIP",
  MOBILE: "MOBILE",
};

export const SIP_STATES = {
  CONNECTED: "CONNECTED",
  NOT_CONNECTED: "NOT_CONNECTED",
};

export const REQ_STATE = {
  NONE: "NONE",
  INITIATED: "INITIATED",
  INITIATED_STEP2: "INITIATED_STEP2",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
  CONNECTED: "CONNECTED",
};

export const TRANSFER_TYPE = {
  CONFERENCE: "CONFERENCE",
  TRANSFER: "TRANSFER",
  TRANSFER_TO_QUEUE: "TRANSFER_TO_QUEUE",
  TRANSFER_TO_EXTERNAL_NUM: "TRANSFER_TO_EXTERNAL_NUM",
};

export const getInitialCallStates = () => {
  let initialCallStates = {
    drag: null,
    call_type: null,
    is_bdtmf: null,
    hide_tc: false,
    callEvent: null,
    callInitialEvent: null,
    firstAgentCallEvent: null,
    agentAnswerEvent: null,
    customerAnswerEvent: null,
    callCurrentEvent: null,
    call_state: constants.CALL_STATES.CALL_NONE,
    isCallInitialEvent: false,
    call_unique_id: null,
    call_start_time: null,
    call_solution: null,
    customers: {},
    customer: null,
    call_queue_name: null,
    conference_agent: null,
    transfer_agent: null,
    events: [],
    transfer_type: "",
    queue: null,
    transfer_state: REQ_STATE.NONE,
    legc_event_customer_answer: null,
    agentCalled: false,
    agentAnswered: false,
    customerCalled: false,
    dialerType: false,
    firstCallAnswerEvent: false,
    firstCustomerCallEvent: false,
    customer_version: 0,
    eventsMap: {},
    deferredOpenWindow: false,
    view_state: constants.CALL_VIEW_STATES.CALL_VIEW,
    sip_user: null,
    hide_queue_tc: false,
    previous_view_state: false,
    txnid: 0,
    transfer_error: 0,
    conference_agent_call: {}
  };
  initialCallStates[constants.CALL_COMMANDS.HOLD] =
    constants.HOLD_STATES.ON_UNHOLD;
  initialCallStates[constants.CALL_COMMANDS.MUTE] =
    constants.MUTE_STATES.NOT_ON_MUTE;
  initialCallStates[constants.CALL_COMMANDS.DIALPAD] = 
    constants.DIALPAD_STATE.DIALPAD_OPENED;
  return initialCallStates;
};

export const getNewCallState = (stateType, state) => {
  const initialTickerState = {
    logs: [],
    logs_changed: 0,
    ice_settings: false,
    is_sip_user_acknowledged: false,
    ticker_initiator: null,
    ticker_initial_customer_number: "",
    ticker_initial_agent_number: "",
    ticker_initial_srnumber: "",
    ticker_initial_callerid: "",
    ticker_initial_customer: null,
    ticker_state: constants.C2C_CONSTANTS.C2C_STATE_NONE,
    window_state: constants.C2C_CONSTANTS.WINDOW_STATE_CLOSED,
    window_state_counter: 0,
    c2c_call_is_promotional: false,
    c2c_sr_number: null,
    c2c_customer_number: null,
    c2c_cli_number: null,
    call_preference_flag: CALL_PREFERENCE_FLAG.MOBILE,
    call_customer_number: null,
    call_agent_info: null,
    is_mpls_account: false,
    phone_switch_agent: null,
    phone_switch_state: "phone",
    phone_switch_state_changed: 1,
    sipAgent: null,
    phoneAgent: null,
    sip_connected: null,
    sip_tried: false,
    sip_retry: 1,
    sip_call_event_type: null,
    sip_call_event: null,
    sip_event_info: null,
    is_sip_call: true,
    sip_command: null,
    solution: null,
    session_agent: null,
    session_agent_numbers: null,
    hangup_reason: null,
  };

  let _initialCallState = getInitialCallStates();
  _initialCallState = JSON.parse(JSON.stringify(_initialCallState));
  if (stateType === "reset") {
    const newState = { ...state, ..._initialCallState };
    return newState;
  } else {
    const newState = { ...initialTickerState, ..._initialCallState };
    return newState;
  }
};

export const actionTypes = {
  Open: "Open",
  Close: "Close",
  Toggle: "Toggle",
  Minimize: "Minimize",
  onCallEvent: "onCallEvent",
  onCallViewState: "onCallViewState",
  onCallPreferenceChange: "onCallPreferenceChange",
  onSipStateChange: "onSipStateChange",
  onSetAgentNumbers: "onSetAgentNumbers",
  onCallStateChange: "onCallStateChange",
  onSetTickerState: "onSetTickerState",
  onResetCallState: "onResetCallState",
};

export const reducer = (state = getNewCallState(null), action) => {
  switch (action.type) {
    case "[Auth] Logout Action": {
      const newState = getNewCallState("clear", state);
      return {
        ...newState,
        window_state: constants.C2C_CONSTANTS.WINDOW_STATE_CLOSED,
        window_state_counter: state.window_state_counter + 1,
      };
    }

    case actionTypes.Open: {
      return {
        ...state,
        window_state: constants.C2C_CONSTANTS.WINDOW_STATE_OPENED,
        window_state_counter: state.window_state_counter + 1,
      };
    }
    case actionTypes.Close: {
      return {
        ...state,
        window_state: constants.C2C_CONSTANTS.WINDOW_STATE_CLOSED,
        window_state_counter: state.window_state_counter + 1,
        view_state: constants.CALL_VIEW_STATES.CALL_NONE,
      };
    }

    case actionTypes.Minimize: {
      return {
        ...state,
        window_state: constants.C2C_CONSTANTS.WINDOW_STATE_MINIMIZED,
        window_state_counter: state.window_state_counter + 1,
      };
    }

    case "tlog": {
      let logs = [...state.logs];
      logs.unshift(action.payload);
      const nstate = {
        ...state,
        logs: logs,
        logs_changed: state.logs_changed + 1,
      };
      return nstate;
    }

    case actionTypes.onResetCallState: {
      return getNewCallState("reset", state);
    }

    case actionTypes.onCallEvent: {
      const newState = {
        ...state,
        ...action.payload,
      };
      if (action.payload.callFlow) {
        newState.call_start_time = action.payload.callFlow.call_start_time;
      }

      if (action.payload.callEvent) {
        newState.events = [action.payload.callEvent, ...state.events];
        newState.eventsMap = { ...newState.eventsMap };
        newState.eventsMap[action.payload.callEvent["event_type"]] =
          action.payload.callEvent;
      }
      return newState;
    }
    case actionTypes.onCallViewState: {
      const newState = { ...state };
      Object.keys(action.payload).map((key) => {
        newState[key] = action.payload[key];
      });

      return newState;
    }
    case actionTypes.onSetAgentNumbers: {
      return {
        ...state,
        session_agent_numbers: action.payload.session_agent_numbers,
      };
    }

    case actionTypes.onSetTickerState: {
      const newState = { ...state };
      Object.keys(action.payload).map((key) => {
        newState[key] = action.payload[key];
      });
      return newState;
    }
    case actionTypes.onCallStateChange: {
      const newState = { ...state };
      Object.keys(action.payload).map((key) => {
        newState[key] = action.payload[key];
      });
      return newState;
    }
    default:
      return state;
  }
};
